import { EllipsisCellRenderer } from '../../../components/CellRenderers';
import { FormattedMessageWithTooltipHeaderRenderer } from '../../../components/HeaderRenderers';
import {
    gridNumberFormatter,
    formattedNumberValueGetter,
    csvDateHeaderValueGetter,
} from '../../../components/ValueFormatters';
import createCSVValueGetter from '../../../components/ValueFormatters/createCSVValueGetter';
import createGridValueFormatter from '../../../components/ValueFormatters/createGridValueFormatter';
import { updateTimeFormatterUTC } from '../../../components/ValueFormatters/updateTimeFormatterUTC';
import { normalizeColumnDefs } from '../../../utils';
import { leftPinnedColumn, keyColumn, numericColumn } from '../../columns';
import * as FIELDS from '../../fields';
import { TODAY_REPORT_ID } from './todayReportId';

const todayReportColumnDefinition = [
    {
        headerName: FIELDS.TIME.label,
        headerValueGetter: FIELDS.TIME.headerValueGetter,
        headerComponentParams: FIELDS.TIME.headerComponentParams,
        field: FIELDS.TIME.field,
        type: [leftPinnedColumn, keyColumn],
        valueFormatter: createGridValueFormatter(updateTimeFormatterUTC),
        maxWidth: 180,
        csvValueGetter: createCSVValueGetter(updateTimeFormatterUTC),
        cellRenderer: EllipsisCellRenderer,
        cellRendererParams: { lines: 2 },
        csvHeaderValueGetter: csvDateHeaderValueGetter,
    },
    ...[
        FIELDS.IMPRESSIONS,
        FIELDS.VISIBLE_IMPRESSIONS,
        FIELDS.VCPM,
        FIELDS.VCTR,
        FIELDS.CLICKS,
        FIELDS.AVERAGE_CPC,
        FIELDS.CVR,
        FIELDS.CVR_CLICKS,
        FIELDS.CVR_VIEWS,
        FIELDS.CONVERSIONS,
        FIELDS.CONVERSIONS_CLICKS,
        FIELDS.CONVERSIONS_VIEWS,
        FIELDS.CPA,
        FIELDS.CPA_CLICKS,
        FIELDS.CPA_VIEWS,
        FIELDS.SPENT,
        FIELDS.CONVERSIONS_VALUE,
        FIELDS.ROAS,
        FIELDS.ROAS_CLICKS,
        FIELDS.ROAS_VIEWS,
    ].map(
        ({
            label,
            headerValueGetter,
            headerComponentParams,
            field,
            renderParams,
            csvValueGetter,
            referenceColId,
            permissions,
            visibilityCondition,
        }) => ({
            headerName: label,
            headerValueGetter: headerValueGetter || FormattedMessageWithTooltipHeaderRenderer,
            headerComponentParams,
            field,
            referenceColId,
            type: [numericColumn],
            valueFormatter: gridNumberFormatter,
            cellRendererParams: renderParams,
            csvValueGetter: csvValueGetter || formattedNumberValueGetter,
            permissions,
            visibilityCondition,
        })
    ),
];

export default normalizeColumnDefs(todayReportColumnDefinition, TODAY_REPORT_ID);
